module.exports = __webpack_public_path__ + "static/media/reception@2x.ec9e9ef1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/reception@2x.png
 ** module id = 2357
 ** module chunks = 44
 **/